import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'

import { createStore } from 'redux'
import { Provider } from 'react-redux'


const reducers = ( state="Default State", action ) => {
	return state;
}
const store = createStore( reducers,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
 );

ReactDOM.render(
	<Provider store={store}>
		<Router>
			<App />
		</Router>
	</Provider>
	, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js